import React from "react";
import "./mainuserpage.css";
import dash from "../../../img/undraw_task_re_wi3v.svg";
import { Fade } from "react-awesome-reveal";
import { Link } from "react-router-dom";
const MainUserpage = () => {
  const colors = ["#0d6efd", "#a31a27", "#198754", "#008aa6"];

  return (
    <div className="container">
      <div className="mainadminpage">
        <Fade direction="right">
          <div className="infmy">
            <div className="infoo">
              <h2>أجندة المحامي القضائية</h2>
            </div>
            <hr />
            <div className="myf">
              <ul className="footer-links">
                {/* <h2>الملفات</h2>  */}

                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link to="/user/maintwkel" style={{ color: "#40485b" }}>
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      إدارة التوكيلات
                    </span>
                  </Link>
                  <hr />
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link to="/user/dawemanage" style={{ color: "#40485b" }}>
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      إدارة الدعاوي
                    </span>
                  </Link>
                  <hr />
                </li>

                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link style={{ color: "#40485b" }} to="/user/ajindamuhami">
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      إدارة أجندة المحامي القضائية
                    </span>
                  </Link>
                  <hr />
                </li>
                <li>
                  <i className="fa-solid fa-chevron-left"></i>{" "}
                  <Link to="/user/managework" style={{ color: "#40485b" }}>
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      إدارة العمل الأداري
                    </span>
                  </Link>
                  <hr />
                </li>
                <li>
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>{" "}
                  <Link to="/user/howwork" style={{ color: "#40485b" }}>
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      فيديوهات شرح كيفية الأستخدام
                    </span>
                  </Link>
                  <hr />
                </li>
                <li>
                  <i className="fa-solid fa-arrow-up-right-from-square"></i>{" "}
                  <Link to="/user/sub" style={{ color: "#40485b" }}>
                    <span
                      style={{
                        color: colors[Math.floor(Math.random() * 5) + 1],
                      }}>
                      {" "}
                      الاشتراك
                    </span>
                  </Link>
                  <hr />
                </li>
              </ul>
              {/* <ul className="footer-links">
          <h2>أضافات</h2> 
                    <li >
                      <i className="fa-solid fa-chevron-left"></i>
                      <span onClick={handleShowMain}>حساب رئيسي</span>
                    </li>
                    <li >
                      <i className="fa-solid fa-chevron-left"></i>
                      <span onClick={handleShowSub}>حساب فرعي</span>
                    </li>
          </ul> */}
            </div>
          </div>
        </Fade>
        <Fade direction="left">
          <div className="imges">
            <img src={dash} alt="" />
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default MainUserpage;
